import $ from 'jquery';
import eventBus from 'EventBus';
import themeService from 'ThemeService';
import util from 'util/Util';
import { pickerCfg } from 'pickerCfg';
import undoService from 'UndoService';
import pageSyncService  from 'PageSyncService';
import focusController  from 'FocusController';
import BasePropertyView from 'BasePropertyView';
import formatTemplate from 'properties/theme/texts.ejs';
import Immutable        from 'immutable';
import fontService from 'FontService';

class TextsView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.initializeProperty('text');
        this.initializeProperty('smallText');
        this.initializeProperty('smallHeading');
        this.initializeProperty('mediumHeading');
        this.initializeProperty('largeHeading');
        this.initializeProperty('link');

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change select': 'updateSelectAttributes',
            'click .styleSelectorText': 'updateTextStyleAttributes',
            'click .weightSelectorText': 'updateTextWeightAttributes'
        };

        // Don't change this name without realizing that the base class may assume this name
        this.dropdownPropNames = Immutable.List(
            ['textFontSize', 'textFont', 'smallTextFontSize', 'smallTextFont',
                'smallHeadingFontSize', 'smallHeadingFont', 'mediumHeadingFontSize', 'mediumHeadingFont',
                'largeHeadingFontSize', 'largeHeadingFont', 'linkFontSize', 'linkFont']);

        return this;
    }

    initializeProperty(prop) {
        this.model.set(prop + 'Color', themeService.resolve(this.getColorThemeName(prop)), { silent: true });
        var fontProp = themeService.resolve(this.getFontThemeName(prop)).split(',');

        this.model.set(prop + 'Font', fontProp[0].trim(), { silent: true });
        this.model.set(prop + 'FontSize', fontProp[1].trim(), { silent: true });

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
            this.model.set(prop + 'Weight', 'bold', { silent: true });
        } else {
            this.model.set(prop + 'Weight', 'normal', { silent: true });
        }

        if (this.model.get(prop + 'Weight') === 'normal') {
            this.model.set(prop + 'WeightSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set(prop + 'WeightSelection', this.selectedColor, { silent: true });
        }

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
            this.model.set(prop + 'Style', 'italic', { silent: true });
        } else {
            this.model.set(prop + 'Style', 'normal', { silent: true });
        }

        if (this.model.get(prop + 'Style') === 'normal') {
            this.model.set(prop + 'StyleSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set(prop + 'StyleSelection', this.selectedColor, { silent: true });
        }
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propNameRaw = propName.replace('Style', '');
        const themePropName = this.getFontThemeName(propNameRaw);
        const oldPropValue=this.model.get(propName);

        let style = this.model.get(propName);
        if (this.model.get(propName).indexOf('italic') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            style = 'normal';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            style = 'italic';
        }

        this.model.set(propName, style, { silent: true });
        let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
        themeService._theme[themePropName] = themePropArray.join(',');
        this.render();
        eventBus.trigger(propNameRaw + 'ThemeChange');

        undoService.add({
          undo: () => {
            if (oldPropValue.indexOf('italic') > -1) {
              this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            } else {
              this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            }
            this.model.set(propName, oldPropValue, { silent: true });
            let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
            themeService._theme[themePropName] = themePropArray.join(',');

            //eventBus.trigger(propNameRaw + 'ThemeChange');
            pageSyncService.renderCurrentPageView();
            focusController.switchPropsViews();
          },
          redo: () => {
            if (style.indexOf('italic') > -1) {
              this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            } else {
              this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            }
            this.model.set(propName, style, { silent: true });
            let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
            themeService._theme[themePropName] = themePropArray.join(',');
            //eventBus.trigger(propNameRaw + 'ThemeChange');
            pageSyncService.renderCurrentPageView();
            focusController.switchPropsViews();
          }
        })
    }

    updateTextWeightAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propNameRaw = propName.replace('Weight', '');
        const themePropName = this.getFontThemeName(propNameRaw);
        const oldPropValue=this.model.get(propName);

        let weight = this.model.get(propName);
        if (this.model.get(propName).indexOf('bold') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            weight = 'normal';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            weight = 'bold';
        }

        this.model.set(propName, weight, { silent: true });
        let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
        themeService._theme[themePropName] = themePropArray.join(',');
        this.render();
        eventBus.trigger(propNameRaw + 'ThemeChange');

      undoService.add({
        undo: () => {
          if (oldPropValue.indexOf('bold') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
          } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
          }
          this.model.set(propName, oldPropValue, { silent: true });
          let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
          themeService._theme[themePropName] = themePropArray.join(',');
          //eventBus.trigger(propNameRaw + 'ThemeChange');
          pageSyncService.renderCurrentPageView();
          focusController.switchPropsViews();
        },
        redo: () => {
          if (weight.indexOf('bold') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
          } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
          }
          this.model.set(propName, weight, { silent: true });
          let themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
          themeService._theme[themePropName] = themePropArray.join(',');
          //eventBus.trigger(propNameRaw + 'ThemeChange');
          pageSyncService.renderCurrentPageView();
          focusController.switchPropsViews();
        }
      })
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const propNameRaw = propName.replace('Color', '');
        const themePropName = this.getColorThemeName(propNameRaw);
        const oldValue = this.model.get(propName);
        const oldThemeValue = themeService._theme[themePropName];

        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color,{silent:true});
            themeService._theme[themePropName] = color;
            this.render();
            $(`#${propName}`).val(color);
            $(`#${propName}Color`).val(color);
            eventBus.trigger(propNameRaw + 'ThemeChange');
            this.addUndoRedoAction(propName,themePropName,oldValue,oldThemeValue,color)
        }
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldValue = this.model.get(propName);
        const propNameRaw = propName.replace('Color', '');
        const themePropName = this.getColorThemeName(propNameRaw);
        const oldThemeValue = themeService._theme[themePropName];

        let color = this.resolveColor(propVal);
        this.model.set(propName, color,{silent:true});
        themeService._theme[themePropName] = color;
        this.render();
        $(`#${propName}`).val(color);
        $(`#${propName}Color`).val(color);
        eventBus.trigger(propNameRaw + 'ThemeChange');
        this.addUndoRedoAction(propName,themePropName,oldValue,oldThemeValue,color,propNameRaw);
    }

    addUndoRedoAction(propName,themePropName,oldValue,oldThemeValue,currentColor,propNameRaw){
        undoService.add({
            undo:() => {
                this.model.set(propName, oldValue,{silent:true});
                themeService._theme[themePropName] = oldThemeValue;
                //eventBus.trigger(propNameRaw + 'ThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $(`#${propName}`).val(oldValue);
                $(`#${propName}Color`).val(oldValue);
            },
            redo: () => {
                this.model.set(propName,currentColor,{silent:true});
                themeService._theme[themePropName] = currentColor;
                //eventBus.trigger(propNameRaw + 'ThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $(`#${propName}`).val(currentColor);
                $(`#${propName}Color`).val(currentColor);
            }
        })
    }

    updateSelectAttributes(ev, name, val, dataKey) {
        ev.preventDefault();
        const propName = name || ev.currentTarget.name;
        const propVal = val || ev.currentTarget.value;

        const key = dataKey || ev.currentTarget.attributes["data-key"].value;
        let propNameRaw = propName.replace('FontSize', '');
        propNameRaw = propNameRaw.replace('Font', '');
        const themePropName = this.getFontThemeName(propNameRaw);

        const oldValue = this.model.get(propName);
        const oldThemeValue = themeService._theme[themePropName];

        this.model.set(propName, propVal,{silent:true});
        var themePropArray = [this.model.get(propNameRaw + 'Font'), this.model.get(propNameRaw + 'FontSize'), this.model.get(propNameRaw + 'Weight'), this.model.get(propNameRaw + 'Style')];
        themeService._theme[themePropName] = themePropArray.join(',');
        themeService.updateTextObjectsFontChanged(key);
        this.render();
        eventBus.trigger(propNameRaw + 'ThemeChange');

        undoService.add({
            undo:() => {
                this.model.set(propName, oldValue,{silent:true});
                themeService._theme[themePropName] = oldThemeValue;
                themeService.updateTextObjectsFontChanged(key);
                //eventBus.trigger(propNameRaw + 'ThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                this.model.set(propName, propVal,{silent:true});
                themeService._theme[themePropName] = themePropArray.join(',');
                themeService.updateTextObjectsFontChanged(key);
                //eventBus.trigger(propNameRaw + 'ThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }


    getColorThemeName(propName) {
        switch (propName) {
            case 'text':
                return '~textColor';
            case 'smallText':
                return '~smallTextColor';
            case 'smallHeading':
                return '~smallHeadingTextColor';
            case 'mediumHeading':
                return '~mediumHeadingTextColor';
            case 'largeHeading':
                return '~largeHeadingTextColor';
            case 'link':
                return '~linkTextColor';
            default:
                break;
        }
    }

    getFontThemeName(propName) {
        switch (propName) {
            case 'text':
                return '~textFont';
            case 'smallText':
                return '~smallTextFont';
            case 'smallHeading':
                return '~smallHeadingFont';
            case 'mediumHeading':
                return '~mediumHeadingFont';
            case 'largeHeading':
                return '~largeHeadingFont';
            case 'link':
                return '~linkFont';
            default:
                break;
        }
    }

    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        } 

        util.prepareComboWidget(this.$el, this);

        const fonts = fontService.loadFontsDropDown(false);
        $("#textFont").append(fonts);
        $("#smallTextFont").append(fonts);
        $("#largeHeadingFont").append(fonts);
        $("#mediumHeadingFont").append(fonts);
        $("#smallHeadingFont").append(fonts);
        $("#linkFont").append(fonts);

        this.createEditableDropDown('textFontSize');
        this.createEditableDropDown('smallTextFontSize');
        this.createEditableDropDown('largeHeadingFontSize');
        this.createEditableDropDown('mediumHeadingFontSize');
        this.createEditableDropDown('smallHeadingFontSize');
        this.createEditableDropDown('linkFontSize');

        // Update via this.dropdownPropNames:
        this.updateForm();
        this.delegateEvents();
        return this;
    }

}

export default TextsView;
